import React from 'react';
import classNames from 'classnames';
import './AsideRunnerLine.css';

interface Props {
  cities: Array<string>,
  className?: string,
}

function shuffle(arr: Array<string>): Array<string> {
  const result = [];
  const copy = [...arr];
  while (copy.length > 0) {
    result.push(copy.splice(Math.floor(Math.random() * copy.length), 1)[0]);
  }
  return result;
}

function AsideRunnerLine(props: Props): JSX.Element {
  const { cities, className } = props;
  const currentClass: {[key: string]: boolean} = {
    'aside-runner-line': true
  };
  const shuffledCities = shuffle(cities);
  
  if (className) currentClass[className] = true;
  
  return (
    <div className={classNames(currentClass)}>
      {
        Object.keys(Array.from({length: 4})).map((idx): JSX.Element => {
          return (
            <div key={`aside-subline-${idx}`} className={`subline subline-${idx}`}>
              { shuffledCities.map((c) => <span className="aside-runner-line-city" key={c}>{c}</span>) }
            </div>
          )
        })
      }
    </div>
  );
}

export default AsideRunnerLine;
